import Toast from '@/components/ui/Toast/toast';

type ToastType = 'info' | 'success' | 'error';

const handleCopyText = (type: ToastType, text: string, title: string, containerClassName: string, hideCloseButton: boolean) => {
  navigator.clipboard.writeText(text);
  Toast({
    type,
    title,
    containerClassName,
    hideCloseButton,
  });
};

export default handleCopyText;
